import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Swal from 'sweetalert2';
import { get_token } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';


export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.get_membership_types();
        this.get_billing_cycle_choices();
        this.fetch_memberships();

        $('#create_membership').on('hidden.bs.modal', () => {
            this.resetForm();
            this.errors = {};
        });
    },
    created() {
        this.fetch_availabe_perks();
    },

    data() {
        return ({
            memberships: [],
            membership_id: '',
            membership_name: '',
            membership_description: '',
            membership_price: 0,
            membership_type: '',
            custom_membership_type: '',
            membership_perks: [],
            billing_cycle: '',
            billing_cycle_choices: [],
            selected_membership_id: '',
            membership_types: [],
            errors: {},
            isSubmitting: false,
            isLoading: false,
            token_exists: false,
            available_perks: [],
            new_perks: [],
            editMembershipData: {
                id: null,
                name: '',
                description: '',
                type_id: '',
                custom_type: '',
                price: '',
                billing_cycle_id: '',
            },
            total_paid_users:{}
        });
    },


    methods: {
        getToken() {
            return get_token();
        },
        toggleSidebar() {
            this.$refs.sidebar.$el.classList.toggle("close");
        },

        get_membership_types() {
            this.isLoading = true;
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_membership_types/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.membership_types = response.data.membership_type;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },

        get_billing_cycle_choices() {
            this.isLoading = true;
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_billing_cycles/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.billing_cycle_choices = response.data.billing_cycles;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

        },
        createMembership() {
            if (!this.validateMembershipForm()) {
                return;
            }

            Swal.fire({
                title: 'Submitting...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('membership_name', this.membership_name);
            formData.append('description', this.membership_description);
            if (this.custom_membership_type) {
                formData.append('membership_type', this.custom_membership_type);
            } else {
                formData.append('membership_type', this.membership_type);
            }
            formData.append('price', this.membership_price);
            formData.append('billing_cycle', this.billing_cycle);

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership/`,
                data: formData,
                processData: false,
                contentType: false,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                },
                success: (response) => {
                    const status = response.status;

                    if (status === "success") {
                        Swal.fire({
                            icon: "success",
                            title: "Membership created",
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.fetch_memberships();
                            this.resetForm();
                            $('#create_membership').modal('hide');
                        });
                    }
                },
                error: (response) => {
                    Swal.close();
                    const response_data = response.responseJSON;
                    if (response_data) {
                        this.errors = response_data;
                    }
                },
                complete: () => {
                    this.isSubmitting = false;
                },
            });
        },

        fetch_memberships() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.memberships = response.data.memberships;

                    if (this.memberships.length > 0) {
                        const firstMembership = this.memberships[0];
                        this.membership_perks = firstMembership.membership_perks.map(p => ({
                            id: p.perk.id,
                            name: p.perk.name
                        }));
                    } else {
                        this.membership_perks = [];
                    }

                    this.memberships.forEach((membership) => {
                        this.total_paid_user(membership.id);
                    })


                    this.$nextTick(() => {
                        $('.table').DataTable().destroy();  // Destroy previous instance if exists
                        $('.table').DataTable({
                            paging: true,
                            searching: true,
                            ordering: true,
                            info: true,
                            lengthChange: true,
                            pageLength: 10,
                            language: {
                                paginate: {
                                    previous: "Previous",
                                    next: "Next"
                                },
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "No entries available"
                            }
                        });
                    });
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },
        toggleMembership(membership){
            membership.is_active = !membership.is_active;
            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/toggle_membership_status/`,
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                data: JSON.stringify({
                    membership_id: membership.id,
                    is_active: membership.is_active
                }),
                success: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Membership status updated successfully.',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    });
                },
            });
        },
        validateMembershipForm() {
            this.errors = {};
            let isValid = true;
            if (!this.membership_name.trim()) {
                this.errors.membership_name = 'Membership name is required.';
                isValid = false;
            }

            if (!this.membership_type && !this.custom_membership_type) {
                this.errors.membership_type = "Please select or enter a membership type.";
                return;
            }

            return isValid;
        },


        resetForm() {
            this.membership_name = '';
            this.membership_description = '';
            this.membership_type = '';
            this.custom_membership_type = '';
            this.membership_price = 0;
            this.billing_cycle
            this.errors = {};
        },

        fetch_availabe_perks() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_perks/`,
                method: "POST",  // Changed to GET
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    // Save available perks for dropdown or suggestions
                    this.available_perks = response.data.perks;

                    const memberships = response.data.memberships;

                    if (Array.isArray(memberships) && memberships.length > 0) {
                        const membership_perks = memberships[0].membership_perks;

                        if (Array.isArray(membership_perks)) {
                            this.membership_perks = membership_perks.map(item => ({
                                id: item.perk.id,      // Correct path
                                perk: item.perk.name   // For display/fallback
                            }));
                        } else {
                            this.membership_perks = [];
                        }
                    } else {
                        this.membership_perks = [];
                    }

                    // Add an empty input if none exist
                    if (this.membership_perks.length === 0) {
                        this.add_perk_input();
                    }

                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },

        open_manage_perks_modal(membership_id) {
            this.selected_membership_id = membership_id;
            this.membership_perks = []; // Reset selected perks
            this.fetch_availabe_perks(); // Fetch perks when modal opens
            $('#manage_perks_modal').modal('show');
        },

        remove_perk(index) {
            this.membership_perks.splice(index, 1);
        },

        add_perk_input() {
            this.membership_perks.push({ id: null, perk: "" }); // Add an empty perk object
        },

        save_perks_function() {
            // Prepare payload
            const payload = {
                membership_perks: this.membership_perks.map(perk => {
                    // Check if it's a valid ID or a string for a new perk
                    return perk.id ? perk.id : (perk.perk || "").trim();
                }),
                membership_id: this.selected_membership_id
            };

            // Make AJAX request
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership_perks/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Perks added successfully.',
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                    $('#manage_perks_modal').modal('hide');
                    this.fetch_memberships(); // Refresh the memberships list
                },
                error: (xhr) => {
                    var error_response_data = JSON.parse(xhr.responseText);
                    if (error_response_data.status) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Process failed.',
                            text: error_response_data.message,
                            showConfirmButton: false,
                            timer: 3000,
                            position: 'bottom-end',
                            toast: true
                        });
                    }
                }
            });
        },
        editMembership(membership) {
            this.editMembershipData = {
                id: membership.id,
                name: membership.name,
                description: membership.description || '',
                type_id: membership.membership_type?.id || '',
                custom_type: membership.custom_type || '',
                price: membership.membership_pricing.length > 0 ? membership.membership_pricing[0].price : '',
                billing_cycle_id: membership.billing_cycle?.id || '',
            };
            this.errors = {};
        },

        updateMembership() {
            const payload = {
                membership_id: this.editMembershipData.id,
                membership_name: this.editMembershipData.name,
                description: this.editMembershipData.description,
                membership_type: this.editMembershipData.custom_type || this.editMembershipData.type_id,
                billing_cycle: this.editMembershipData.billing_cycle_id,
                membership_price: this.editMembershipData.price,

            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_membership/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),


                success: (response) => {
                    const updatedData = response.data;

                    this.memberships = this.memberships.map((membership) => {
                        if (membership.id === updatedData.id) {
                            return updatedData;
                        }
                        return membership;
                    });
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Membership updated successfully.',
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                    $('#update_membership').modal('hide');
                },
                error: (xhr) => {
                    this.errors = xhr.responseJSON;
                }
            });
        },

        delete_membership(membership_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {

                    const request_data = JSON.stringify({ membership_id: membership_id });

                    const headers = {
                        'Authorization': `Token ${this.getToken()}`,
                        'Content-Type': 'application/json'
                    };

                    const url = `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_membership/`;

                    $.ajax({
                        type: 'DELETE',
                        url: url,
                        headers: headers,
                        data: request_data,
                        contentType: 'application/json',
                        success: (response) => {
                            if (response.status === "success") {
                                this.memberships = this.memberships.filter(m => m.id !== membership_id);
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Membership deleted',
                                    showConfirmButton: false,
                                    timer: 2000,
                                    position: 'bottom-end',
                                    toast: true
                                });
                            } else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Sorry',
                                    text: 'Could not delete membership.',
                                    confirmButtonText: 'OK',
                                    position: 'bottom-end',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            let errorMessage = 'Could not delete membership.';

                            if (xhr.responseJSON) {
                                if (xhr.responseJSON.message) {
                                    // Handles both string and object messages
                                    if (typeof xhr.responseJSON.message === 'string') {
                                        errorMessage = xhr.responseJSON.message;
                                    } else if (typeof xhr.responseJSON.message === 'object') {
                                        // If message is a validation error dict, get first value
                                        const firstKey = Object.keys(xhr.responseJSON.message)[0];
                                        errorMessage = xhr.responseJSON.message[firstKey][0];
                                    }
                                }
                            }

                            Swal.fire({
                                icon: 'error',
                                title: 'Sorry',
                                text: errorMessage,
                                confirmButtonText: 'OK',
                                position: 'bottom-end',
                                showConfirmButton: false,
                                timer: 3000,
                                toast: true
                            });
                        }


                    });
                }
            });
        },

        total_paid_user(membership_id) {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/total_paid_users_per_membership/?membership_id=${membership_id}`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.total_paid_users[membership_id] = response.total_paid_users;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        }



    },
    watch: {
        membership_type(newVal) {
          if (newVal) {
            this.custom_membership_type = '';
          }
        },
        custom_membership_type(newVal) {
          if (newVal) {
            this.membership_type = '';
          }
        }
      }


}